<div class="h-100 cs-d-flex align-items-center"
     *ngIf="params && selectList && selectList.length && !showValueOnly">
    <select (change)="onClickAction($event.target.value)" class="ag-grid-select" [style.background-color]="selectedItem ? selectedItem.color : '#fff'" [ngModel]="params.value">
        <option *ngFor="let item of selectList" [style.background-color]="item ? item.color : '#fff'" [value]="item.id">{{item.name}}</option>
    </select>
</div>
<div class="ag-grid-value-only" *ngIf="showValueOnly" [style.background-color]="selectedItem ? selectedItem.color : '#fff'">
    {{selectedItem.name}}
</div>

